import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=0ca89985"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"
import style0 from "./loginForm.vue?vue&type=style&index=0&id=0ca89985&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports